import type { BidType } from '@/features/bidding/constants'
import type {
  ExtendedBidPtu,
  ForecastPtu,
  OfferedAndForecastAndSuggestedPtu,
  SuggestedBid,
} from '@/features/bidding/types/bid'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'
import getBidConfig from '@/features/bidding/utils/getBidConfig'

const DEFAULT_VOLUME = 0

export const buildDefaultOfferedBid = (
  selectedCountry: CountryIdentifier,
  date: MarketDate,
  bidType: BidType,
): ExtendedBidPtu[] => {
  const startOfDay = date.getStartOfDay()
  const startOfNextDay = startOfDay.plus({ day: 1 })
  const { ptuLengthInMin, volumeUnit } = getBidConfig(selectedCountry, bidType)

  const numberOfPtus = startOfNextDay.diff(startOfDay, 'minutes').minutes / ptuLengthInMin

  return Array.from({ length: numberOfPtus }, (_, index) => {
    const start = startOfDay.plus({ minutes: index * ptuLengthInMin })
    const end = startOfDay.plus({ minutes: index * ptuLengthInMin + ptuLengthInMin })

    return {
      ptu: { start, end },
      offeredVolume: { quantity: DEFAULT_VOLUME, unit: volumeUnit },
    }
  })
}

export const combineOfferedAndForecast = (
  offer: ExtendedBidPtu[],
  forecast?: ForecastPtu[],
  suggestedBids?: SuggestedBid[],
): OfferedAndForecastAndSuggestedPtu[] =>
  offer.map((offeredPtu) => ({
    ptu: offeredPtu.ptu,
    offeredVolume: offeredPtu.offeredVolume,
    offeredPtuChunks: offeredPtu.ptuChunks,
    forecastedVolume: forecast?.find((forecastPtu) => forecastPtu.ptu.start.equals(offeredPtu.ptu.start))?.volume,
    suggestedVolume: suggestedBids?.find((suggestedBid) => suggestedBid.ptu.start.equals(offeredPtu.ptu.start))?.volume,
  }))
